import styled from "styled-components/macro";

import { rgba } from "global-styles/lib/colors";

import { TextButton } from "components/Button/Text/styles";

export const SkipButton = styled(TextButton)`
  color: ${({ theme }) => rgba(theme.colors.text, 0.4)};
`;
